import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-wrapper">
        <div className="footer-grid">
          <div className="footer-section">
            <h4>⚙️ Services</h4>
            <ul>
              <li>
                <Link to="/services">💻 Electronics Development</Link>
              </li>
              <li>
                <Link to="/services">🔌 Embedded Systems &amp; IoT</Link>
              </li>
              <li>
                <Link to="/services">🤖 AI/ML Solutions</Link>
              </li>
              <li>
                <Link to="/services">🏭 Industrial Automation</Link>
              </li>
            </ul>
          </div>

          {/* ── Media Gallery section ── */}
          

          <div className="footer-section">
            <h4>🌐 Connect</h4>
            <ul>
              <li>
                <a href="tel:+919370329886" className="info-link">📞 Call Us</a>
              </li>
              <li>
                <a href="mailto:contact@aashman.in">📧 contact@aashman.in</a>
              </li>
               <li>
                <Link to="/media-gallery">🎬 Media Gallery</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section footer-address">
            <h4>📍 Address</h4>
            <div className="address-content">
              <p className="address-text">
                Aashman Technicals Pvt. Ltd.<br/>
                Sr.No. 81/4, Shri. Guru Datta Mandit Lane,<br />
                Dangat Industrial Estate, 2nd Kamaan,<br />
                Shivane, Pune<br />
                Maharashtra - 411058<br />
                India
              </p>
              <a href="https://maps.app.goo.gl/JSY2WZGeRfcxnckr6" target="_blank" rel="noopener noreferrer" className="map-link">
                🗺️ View on Map
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">© {currentYear} Aashman Technicals Pvt. Ltd.<br className="mobile-break" /> All rights reserved.</p>
          <div className="footer-links">
            <Link to="/terms-and-conditions" className="footer-legal-link">
              Terms &amp; Conditions
            </Link>
            <span className="footer-links-separator" aria-hidden="true">
              ·
            </span>
            <span>🇮🇳 Made in India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;